import Vue from 'vue'
import { alertError } from './http'
import { enhance } from './vue-enhance'
//import 'element-ui/lib/theme-chalk/index.css'
import './assets/element-#36C1CD/index.css'
import ElementUI from 'element-ui'
import ProgressBar from 'vue-progressbar'
import { router } from './router'
import { store } from './store'
import App from './app.vue'
import './assets/style.less'

Vue.config.productionTip = false

window.Vue = Vue
Vue.use(enhance)
Vue.use(ProgressBar)
Vue.use(ElementUI, { size: 'small' })
window.addEventListener('error', alertError)
window.addEventListener('unhandledrejection', alertError)

Vue.config.errorHandler = (err, vm, info) => {
  alertError(err)
  throw err
}

window.$vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


